import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDI0bWeCOeSD4ghEURZbEFWTyGATnqnXTw",
  authDomain: "tmtt-tag.firebaseapp.com",
  projectId: "tmtt-tag",
  storageBucket: "tmtt-tag.firebasestorage.app",
  messagingSenderId: "7963549016",
  appId: "1:7963549016:web:0ba972bcf22cd8e7d8d92d",
  measurementId: "G-8J6TK7EQBD"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { app, analytics };
